import { Box, useMediaQuery, useTheme } from "@mui/material";
import { green } from "@mui/material/colors";

import { Typography } from "@initia-digital/component-library";


export const ContinuingWorkAlert = () => {
    // ----------------------------------------

    // MUI HOOKS
    const theme = useTheme();
    const isSmallerThanSm = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box 
            my="5px" px="8px" py="5px"
            border={`1px solid ${green['200']}`} borderRadius="4px"
            lineHeight="1"
        >
            <Typography
                color={green['500']}
                fontSize={isSmallerThanSm ? "0.75rem" : "0.8rem"}
                fontWeight={700}
            >
            {
                `You are linked to a previous prestart meeting or Take-5`
            }
            </Typography>
            <Box lineHeight="1">
                <Typography
                    color={theme.palette.primary.contrastText}
                    fontSize={isSmallerThanSm ? "0.65rem" : "0.7rem"}
                    fontWeight={300}
                >
                {
                    `Focus on recording anything that has changed on site.`
                }
                </Typography>
            </Box>
            <Box lineHeight="1">
                <Typography
                    color={theme.palette.primary.contrastText}
                    fontSize={isSmallerThanSm ? "0.65rem" : "0.7rem"}
                    fontWeight={300}
                >
                {
                    `e.g. changed work location, different activities happening on site, or hazards to add or remove`
                }
                </Typography>
            </Box>
        </Box>
    )
}